import {useEffect, useState, useRef, Component} from 'react';
import MediaQuery from 'react-responsive';

import TextArea from '../../components/textarea-with-label';

import ApplicationHeader from './grants-application-header';
import ApplicationSection from './grants-application-section';

import ButtonPrevious from '../../components/buttons-navigation/button-previous';
import ButtonNext from '../../components/buttons-navigation/button-next';
import RadioButton from '../../components/radio-button';
import checkbox from '../../components/checkbox';

import QuestionTypeInput from './question-types/question-type-text-input';
import QuestionTypeDatePicker from './question-types/question-type-date-picker';
import QuestionTypeDropdown from './question-types/question-type-dropdown';
import QuestionTypeCurrencyInput from './question-types/question-type-currency-input';
import QuestionTypeTable from './question-types/question-type-table';
import QuestionTypeUploadDocs from './question-types/question-type-upload-documents';
import QuestionTypeCheckboxes from './question-types/question-type-checkboxes';
import QuestionTypeRadioButtons from './question-types/question-type-radio-buttons';
import QuestionTypeSicCode from './question-types/question-type-sic-code';

import questionChunk from "../../lib/applications/question-chunk";

import ApplicationApi from '../../lib/applications/application-api';

import FileUploader from '../../components/popups/images/file-uploader-popup';

import QuestionTypes from './question-types/question-types';
import FileUpload from "../../components/file-upload";

import MobileBlockPopup from './grants-application-mobile-block-popup';

export default class GrantsApplicationPageContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validation: [],
            showErrors: false,
            showFileUploader: false,
            mobileBlock: false,
        }

        this.questionTypes = {
            'text-input': QuestionTypeInput,
            'dropdown-selection': QuestionTypeDropdown,
            'radio-buttons': QuestionTypeRadioButtons,
            'date-picker': QuestionTypeDatePicker,
            'checkboxes': QuestionTypeCheckboxes,
            'currency-input': QuestionTypeCurrencyInput,
            'table-input': QuestionTypeTable,
            'upload-documents': QuestionTypeUploadDocs,
            'sic-code': QuestionTypeSicCode,
        }
    }

    componentDidMount() {

    }

    setMobileBlock(block) {
        this.setState({ mobileBlock: block });
    }

    setShowFileUploader(toggled) {
        this.setState({ showFileUploader: toggled });
    }

    getComponent(question, block) {
        const Component = this.questionTypes[question.type] || TextArea;
        const sectionId = this.props.data.id;

        const error = this.state.validation.find(v => v.sectionId == sectionId && v.questionId == question.id)?.errors || [];


        let title = question.title == undefined || question.title == null ? null : block.show_question_decimal_number === true ? `${question.number}) ${question.title}` :  `${question.title}`;

        if (question.response_required) {
            title = <>{ title } <span style={{
                marginLeft: '5px',
                fontSize: '11px',
                color: '#707070'
            }}>[Required]</span></>;
        }

        let params = {
            value: this.props.getQuestionValue(sectionId, block.id, question.id),
            label: title,
            description: question.description
        }

        let componentParams = {
            key:  `${sectionId}${block.id}${question.id}`,
            question,
            params,
            error,
            showErrors: this.state.showErrors,
            sectionId,
            blockId: block.id,
            getQuestionValue: this.props.getQuestionValue,
            addError: this.addError.bind(this)
        }

        let component = <Component onChange={(e) => this.onChange(e, block.id, question.id)} {...componentParams}/>

        if (question.type == QuestionTypes.UPLOAD_DOCUMENTS) {

            component = <Component onChange={(e) => this.onUploadChange(e, block.id, question.id)} { ...componentParams } applicationId={this.props.application.id}/>
        }

        if (question.type == QuestionTypes.DATE_PICKER) {
            component = <Component onChange={this.onDateChange.bind(this)} { ...componentParams } />
        }

        if (question.type == QuestionTypes.TABLE_INPUT) {
            component = <Component onChange={this.onTableChange.bind(this)} { ...componentParams } />
        }

        if (question.type == QuestionTypes.CHECKBOXES) {
            component = <Component onChange={this.onCheckboxChange.bind(this)} handleQuestionChange={this.props.handleQuestionChange.bind(this)} { ...componentParams } />
        }

        if (question.type == QuestionTypes.RADIO_BUTTONS) {
            component = <Component onChange={this.onRadioChange.bind(this)} handleQuestionChange={this.props.handleQuestionChange.bind(this)} { ...componentParams } />
        }

        return component;
    }

    addError(errorBoolean, errors, sectionId, questionId) {
        let state = this.state.validation;

        if (errorBoolean) {
            const val = state.find(s => s.questionId == questionId);

            if (val) {
                val.errors = errors;
            } else {
                state.push({
                    sectionId: sectionId,
                    questionId: questionId,
                    errors: errors
                });
            }
        } else {
            state = state.filter(s => s.questionId !== questionId);
        }

        this.setState({validation: state})
        this.props.setValidation(state);
    }

    setShowErrors() {
        this.props.setShowErrors(() => this.setState({showErrors: true}));
    }

    pagination(next) {
        if(next === this.props.backClick) {
            if(this.state.validation.length > 0) {
                this.props.onSectionComplete(false, this.props.data.id)
            }
            return this.setState({showErrors: false, validation : []},() => {
                next();
            });
        }

        if (this.state.validation.length > 0) {

            document.querySelector('.content').scrollTo({top: 0, behavior: 'smooth'})

            return this.setState({showErrors: true}, () => this.props.onSectionComplete(false, this.props.data.id))
        }

        this.setState({showErrors: false, validation : []},() => {
            next();
        });

    }

    onTableChange(event, blockId, questionId) {
        const {value} = event;
        const sectionId = this.props.data.id;


        this.props.handleQuestionChange(sectionId, blockId, questionId, value);
    }

    onRadioChange(values, blockId, questionId, index, question) {

        this.props.handleQuestionChange(this.props.data.id, blockId, questionId, values);
    }

    onCheckboxChange(updated, blockId, questionId, index, question) {

        this.props.handleQuestionChange(this.props.data.id, blockId, questionId, updated);
    }

    onDateChange(values, blockId, questionId, callback = null) {
        this.props.handleQuestionChange(this.props.data.id, blockId, questionId, values);
    }

    onUploadChange(e, blockId, questionId) {
        let { value } = e.hasOwnProperty('value') ? e : e.target;

        this.props.handleQuestionChange(this.props.data.id, blockId, questionId, value);
    }

    onChange(e, blockId, questionId) {
        let {label, value} = e.hasOwnProperty('value') ? e : e.target;

        const sectionId = this.props.data.id;

        if (label) return this.props.handleQuestionChange(sectionId, blockId, questionId, label);

        this.props.handleQuestionChange(sectionId, blockId, questionId, value);
    }

    renderSection(block) {
        let title = '';
        console.log(block);
        if (block.title == null) {
            title = null;
        } else {
            if (block.show_section_number) {
                title += `${block.number}) ${block.title}`;
            } else {
                title = block.title;
            }
        }

        return (
            <ApplicationSection title={title} description={block.description}>

                {questionChunk(block.questions, 'text-input', q => {
                    return q.small_input === true;
                }).map((chunk) => {


                    return (
                        <div className="grants-application__row grants-application__info">
                            {
                                this.renderChunk(chunk, block)
                            }
                        </div>
                    );


                    // return this.getComponent(question, block)
                })}
            </ApplicationSection>
        )
    }

    renderChunk(chunk, block) {
        if (chunk.length === 1) {
            return (
                <div className="grants-application-row__item" style={{ width: '100%', flexBasis: 'unset' }}>
                    <div className="utils__row  utils__gap--20">
                        {
                            this.getComponent(chunk[0], block)
                        }

                    </div>
                </div>
            );
        }
        return (
            < >
                {
                    chunk.map((question, index) => {
                        return (
                            <div key={index} className="grants-application-row__item">
                                <div className="utils__row  utils__gap--20">
                                    {
                                        this.getComponent(question, block)

                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </>
        );
    }

    render() {
        const { title, subtitle, data, selectedPage, sections, backClick, nextClick, application } = this.props;

        return (
            <>
                { this.state.mobileBlock && <MobileBlockPopup close={() => this.setMobileBlock(false)}>
                    { this.renderSection(this.state.mobileBlock) }
                </MobileBlockPopup> }

                <ApplicationHeader title={ <div className="state-pages-header__row">
                    <h2 className="state-pages-header__title">{ title }</h2>
                    </div>
                } subtitle={ <div className="state-pages-header__row">
                    <h2 className="state-pages-header__subtitle">{ subtitle }</h2>
                </div>} />
                <div className="state-pages__content">
                    {data?.blocks && data.blocks.length > 0 && data.blocks.map((block) => {
                        return (
                            <>
                                <MediaQuery maxWidth="500px">
                                    { block.mobile_popup ?
                                        <div className="grants-application__mobile-bar" onClick={() => this.setMobileBlock(block)}>
                                            { block.title }
                                            <img src="/assets/rightArrow.svg" />
                                        </div>
                                       : this.renderSection(block)
                                    }
                                </MediaQuery>

                                <MediaQuery minWidth="501px">
                                    { this.renderSection(block) }
                                </MediaQuery>
                            </>
                        )
                    })}
                </div>

                <div className="state-pages__navigation">
                    <ButtonPrevious hide={selectedPage == 0} onClick={() => this.pagination(backClick)}>
                        {
                            <>Back to {sections[selectedPage - 1]?.name ? sections[selectedPage - 1].name : `section ${selectedPage }`} </>
                        }
                    </ButtonPrevious>
                    <ButtonNext hide={selectedPage + 1 > sections.length} onClick={() => this.pagination(nextClick)}>
                        {
                            selectedPage + 1 === sections.length &&
                            <>Review summary of Application</>
                        }
                        {
                            selectedPage + 1 < sections.length &&
                            <>Save and Proceed</>
                        }
                    </ButtonNext>
                </div>
            </>
        )
    }
}
